import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='newfooter'>
      
      <div className="footer-container">
        <div className="footer-section">
          {/* Logo or title here */}
          <h2>GPA Ichalkaranji</h2>
          <p>Connecting Health & Wellness</p>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          </div>
        </div>

        <div className="footer-section ">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/Contact">Contact Us</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/TermsAndConditions">Terms & conditions</a></li>
            <li><a href="/RefundPolicy">Refund Policy</a></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p> Ichalkaranji, India</p>
          <p>Email: gpaichalkaranji@gmail.com</p>
          {/* <p>Phone: +91 12345 67890</p> */}
        </div>

        <div className="footer-section newsletter">
          <h3>Stay Updated</h3>
          <form>
            <input type="email" placeholder="Enter your email" />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <a href="https://sajaratech.com" target="_blank" rel="noopener noreferrer">&copy; {new Date().getFullYear()} GPA Ichalkaranji. Designed by SAJARA Tech.</a>
      </div>
    </footer>
  );
};

export default Footer;
